export default __webpack_public_path__ + "243315c27ef7f7de0208bf05e04ca24a.jpg";